import React from "react";
import { Col, Dropdown, Modal, Table, Tag, Typography } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { deleteStore } from "../Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useQueryClient } from "react-query";
import endPoints from "../EndPoints";
import { ItemType } from "antd/es/menu/interface";
import { useGetStores } from "../ServerSideStates";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import { SecretText } from "apps/Common/SecretString";
import { MazakaBull } from "apps/Common/MazakaBull";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { setBackEndUlr } from "helpers/SetBackEndUrl";

const { Text } = Typography;

const ListItems = () => {
    const navigate = useNavigate()
  const queryClient = useQueryClient();
 
  const columns = [
    {
      title: <PictureOutlined />,

      render: (_: string, record: any) => {
        return (
          <>
            <div className="!flex gap-3 items-center">
              <LazyLoadImage
                wrapperWidth="80px"
                wrapperHeight="80px"
                src={ setBackEndUlr()+"/"+record?.photoUrl}
                alt="logo"
                style={{objectFit:"contain"}}
              />
              <div>
                <div>
                  <Text>{`${record?.user?.name || ""} ${
                    record?.user?.surname || ""
                  }`}</Text>
                </div>
                <div className="!text-indigo-500" >
                  <SecretText textType="phone" text={record?.user?.phoneNumber} />
                </div>
                <div>
                  <Text className="!font-bold" >{record?.storeName || ""}</Text>
                </div>
              </div>
            </div>
          </>
        );
      },
    },
    
    {
      title: "Vergi",

      render: (text: string, record: any) => {
        return (
          <>
            <div>
            <Text
                className="mobile-label"
                data-label="Vergi Dairesi/Vergi Numarası"
              ></Text>
              <div>
                <Text>{record?.taxOffice}</Text>
              </div>
              <div>
                <Text>{record?.taxNumber}</Text>
              </div>
            </div>
          </>
        );
      },
    },
    {
      title: "İl/İlçe",

      render: (text: string, record: any) => {
        return (
          <div className="!flex !flex-col md:!flex-row items-start gap-2 md:!items-center">
            <Text
                className="mobile-label"
                data-label="İl İlçe"
              ></Text>
              {
                record?.city?.name&&
            <Text >{record?.city?.name}</Text>
              }
              {
                record?.district?.name&&
            <Text color="green" >{record?.district?.name}</Text>
              }
          </div>
        );
      },
    },

    {
      title: "Oluşturma Tarihi",
      dataIndex: "insertDate",
      key: "insertDate",
      render: (text: string) => <Text
       className="mobile-label"
                data-label="Oluşturma Tarihi"
      >{dayjs(text).format("DD.MM.YYYY")}</Text>,
    },
    {
        title: "Açıklama",
        dataIndex: "storeDescription",
        key: "storeDescription",
        render: (text: string) => <Text
        className="mobile-label"
                data-label="Açıklama"
        >{text}</Text>,
      },

    {
      title: "Durum",
      dataIndex: "active",
      key: "active",
      render: (status: boolean) => (
       <div className="!flex flex-col gap-2 md:!block" >
        <Text
         className="mobile-label"
                data-label="Durum"
        ></Text>
         <MazakaBull type={status ? "Success" : "Error"} />
       </div>
      ),
    },

    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: "8%",
      render: (key: any, record: any) => (
        <Col className="text-end pr-2">
         <Dropdown menu={{ items: tableItemDropdownMenu(record) }}>
          <EllipsisOutlined/>
          </Dropdown>
        </Col>
      ),
    },
  ];

  const tableItemDropdownMenu = (record: any): ItemType[] => [
    {
      key: "1",
      onClick: async () => {
        navigate(`/admin/panel/add/store?storeId=${record?.id}`)
        
      },
      icon: <EditOutlined />,
      label: "Güncelle",
    },
    {
      key: "2",
      onClick: () => {
        confirm(record);
      },
      icon: <DeleteOutlined />,
      label: "Sil",
    },
  ];
  const confirm = (record: any) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu öğe silinecek. Onaylıyor musunuz?`,
      okText: "Sil",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          await deleteStore(record);
          openNotificationWithIcon("default", "İşlem Başarılı");
          queryClient.resetQueries({
            queryKey: endPoints.getStoreListFilter,
            exact: false,
          });
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };

  const stores = useGetStores();

  return (
    <Table
    className="!w-full"
      columns={columns}
      dataSource={stores?.data?.data?stores?.data?.data:[]}
      loading={stores.isLoading || stores.isFetching}
      rowKey={"id"}
      pagination={{
        position: ["bottomRight"],
        className: "!px-0",
        // onChange: handleChangePagination,
        total: stores?.data?.data?.length || 0,

        pageSize: 20,
        showLessItems: true,
        size: "small",
        showSizeChanger: true,
        locale: { items_per_page: "" },
        showTotal: (e) => `${e}`,
      }}
    />
  );
};

export default ListItems;
